import IPlanEditor from './IPlanEditor';
import PlanEditorsApi from './PlanEditorsApi';
import * as ActionTypes from './ActionTypes';
import IPlanEditorInput from './IPlanEditorInput';
import { assign } from '../../shared/Assign';

export function listSucceeded(result: IPlanEditor[]) {
    return { type: ActionTypes.LIST_PLAN_EDITORS_SUCCESS, result: result };
}

export function listFailed(error: any) {
    return { type: ActionTypes.LIST_PLAN_EDITORS_FAILURE, error: error };
}

export function list(): (dispatch: (result: any) => void, getState: any) => any {
    return function (dispatch: (result: any) => void, getState: any) {
        return PlanEditorsApi.list()
            .then((result: IPlanEditor[]) => {
                dispatch(listSucceeded(result));
            })
            .catch((error: any) => {
                dispatch(listFailed(error));
                throw error;
            });
    };
}

function newSucceeded(result: any): any {
    return { type: ActionTypes.NEW_PLAN_EDITOR_SUCCESS, result: result };
}

function newFailed(error: any): any {
    return { type: ActionTypes.NEW_PLAN_EDITOR_FAILURE, error: error };
}

export function getNew(): (dispatch: (result: any) => void, getState: any) => any {
    return function (dispatch: (result: any) => void, getState: any) {
        return PlanEditorsApi.new()
            .then((result: any) => {
                dispatch(newSucceeded(result));
            })
            .catch((error: any) => {
                dispatch(newFailed(error));
                throw error;
            });
    };
}

function createSucceeded(result: IPlanEditor): any {
    return { type: ActionTypes.CREATE_PLAN_EDITOR_SUCCESS, result: result };
}

function createFailed(error: any): any {
    return { type: ActionTypes.CREATE_PLAN_EDITOR_FAILURE, error: error };
}

export function create(planEditor: any): (dispatch: (result: any) => void, getState: any) => any {
    return function (dispatch: (result: any) => void, getState: any) {
        return PlanEditorsApi.create(planEditor)
            .then((result: IPlanEditor) => {
                dispatch(createSucceeded(result));
            })
            .catch((error: any) => {
                dispatch(createFailed(error));
                throw error;
            });
    };
}

function editSucceeded(result: any): any {
    return { type: ActionTypes.EDIT_PLAN_EDITOR_SUCCESS, result: result };
}

function editFailed(error: any): any {
    return { type: ActionTypes.EDIT_PLAN_EDITOR_FAILURE, error: error };
}

export function edit(id: number): (dispatch: (result: any) => void, getState: any) => any {
    return function (dispatch: (result: any) => void, getState: any) {
        return PlanEditorsApi.edit(id)
            .then((result: any) => {
                dispatch(editSucceeded(result));
            })
            .catch((error: any) => {
                dispatch(newFailed(error));
                throw error;
            });
    };
}

function updateSucceeded(result: IPlanEditor) {
    return { type: ActionTypes.UPDATE_PLAN_EDITOR_SUCCESS, result: result };
}

function updateFailed(error: any) {
    return { type: ActionTypes.UPDATE_PLAN_EDITOR_FAILURE, error: error };
}

export function update(input: IPlanEditorInput) {
    return function (dispatch: any, getState: any) {
        let data = assign({}, input);
        delete data.id;
        delete data.planFirmName;
        delete data.typeTranslationKey;

        // TODO: this is temporary solution that should be removed after the modal will have Firstname and Lastname instead of Firstname and Lastname the Name
        const words = data.name.split(/\s+/);
        if (words.length === 1) {
            data.firstname = words[0];
            data.lastname = '';
        } else if (words.length >= 2) {
            data.firstname = words.slice(0, -1).join(' ');
            data.lastname = words[words.length - 1];
        }

        return PlanEditorsApi.update(input.id, data)
            .then((result: any) => {
                dispatch(updateSucceeded(result));
            })
            .catch((error: any) => {
                dispatch(updateFailed(error));
                throw error;
            });
    };
}

function deleteSuccess(result: number) {
    return { type: ActionTypes.DELETE_PLAN_EDITOR_SUCCESS, result: result };
}

function deleteFailed(error: string) {
    return { type: ActionTypes.DELETE_PLAN_EDITOR_FAILURE, error: error };
}

export function deletePlanEditor(
    id: number
): (dispatch: (result: any) => void, getState: any) => any {
    return function (dispatch: (result: any) => void, getState: any) {
        return PlanEditorsApi.delete(id)
            .then((result: any) => {
                dispatch(deleteSuccess(id));
            })
            .catch((error: string) => {
                dispatch(deleteFailed(error));
                throw error;
            });
    };
}
